import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

export const ShellMenuButton = styled(Button) ({
  paddingLeft: "64px",
  paddingRight: "64px",
  paddingTop: "24px",
  paddingBottom: "24px",
  color: "black",
})